import axiosInstance from "../../../../api/axiosConfig";

export const addUser = (data: any) => {
  return axiosInstance.post("/admin/users", data);
};

export const getUser = (id: string) => {
  return axiosInstance.get(`/admin/users/${id}`);
};

export const updateUser = (id: string, data: any) => {
  return axiosInstance.patch(`/admin/users/${id}`, data);
};
